var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleBtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.64 20.2045C29.64 19.5664 29.5827 18.9527 29.4764 18.3636H21V21.845H25.8436C25.635 22.97 25.0009 23.9232 24.0477 24.5614V26.8195H26.9564C28.6582 25.2527 29.64 22.9455 29.64 20.2045Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9998 29C23.4298 29 25.467 28.1941 26.9561 26.8195L24.0475 24.5614C23.2416 25.1014 22.2107 25.4205 20.9998 25.4205C18.6557 25.4205 16.6716 23.8373 15.9638 21.71H12.957V24.0418C14.4379 26.9832 17.4816 29 20.9998 29Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9641 21.71C15.7841 21.17 15.6818 20.5932 15.6818 20C15.6818 19.4068 15.7841 18.83 15.9641 18.29V15.9582H12.9573C12.3477 17.1732 12 18.5477 12 20C12 21.4523 12.3477 22.8268 12.9573 24.0418L15.9641 21.71Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9998 14.5795C22.3211 14.5795 23.5075 15.0336 24.4402 15.9255L27.0216 13.3441C25.4629 11.8918 23.4257 11 20.9998 11C17.4816 11 14.4379 13.0168 12.957 15.9582L15.9638 18.29C16.6716 16.1627 18.6557 14.5795 20.9998 14.5795Z",
    fill: "#EA4335"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleBtn);
export default __webpack_public_path__ + "static/media/google_btn.acc32ad5923dc7b49343a7719fbc9d0f.svg";
export { ForwardRef as ReactComponent };